const Header = () => {
    return null;
};

export default Header;
